import React from 'react';
import EditorTitle from '../Components/Shared/EditorTitle';
import EditorContent from '../Components/Shared/EditorContent';
import CallToAction from '../Components/Shared/CallToAction';
import EditorImage from '../Components/Shared/EditorImage';

export default function renderFromStructure(props) {
  const {
    element,
    onChange = () => {},
    name,
    id = '',
    inEdit = false,
    activityId = null,
    forEmail = false,
    dynamicElement = '',
    columns = 1,
  } = props;
  return element.map((el, index) => {
    const subId = id + index;
    const row = Array.isArray(el) ? { elements: el } : el;

    if (Array.isArray(el) || el?.type === 'row')
      return forEmail ? (
        <tr key={`row-${String(index)}`}>
          <td style={{ padding: '4%', ...(row.style || {}) }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                <tr>
                  {renderFromStructure({
                    ...props,
                    element: row.elements,
                    id: subId,
                    columns: row.elements.length,
                  })}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      ) : (
        <div
          key={`row-${String(index)}`}
          id={index}
          style={{
            display: 'flex',
            alignItems: 'stretch',
            padding: '4%',
            ...(row.style || {}),
          }}
        >
          {renderFromStructure({ ...props, element: row.elements, id: subId })}
        </div>
      );

    if (!COMPONENTS[el?.type]) return null;

    return COMPONENTS[el.type]({
      element: el,
      id: subId,
      inEdit,
      onChange,
      name,
      activityId,
      forEmail,
      dynamicElement,
      columns,
    });
  });
}

const COMPONENTS = {
  // columns sizes this cell only: its own children start a new count
  container: ({ element, id, columns, ...props }) =>
    props.forEmail ? (
      <td
        key={`${element?.type}-${id}`}
        style={{
          verticalAlign: 'top',
          width: `${100 / columns}%`,
          padding: '4%',
          ...(element?.style || {}),
        }}
      >
        {renderFromStructure({ ...props, id, element: element?.elements })}
      </td>
    ) : (
      <div
        key={`${element?.type}-${id}`}
        id={id}
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '4%',
          flexGrow: 1,
          flexBasis: 0,
          alignItems: 'stretch',
          ...(element?.style || {}),
        }}
      >
        {renderFromStructure({ ...props, id, element: element?.elements })}
      </div>
    ),
  img: ({ element, id, inEdit, onChange, forEmail }) => (
    <EditorImage
      id={id}
      key={id}
      alt={element?.alt}
      edit={inEdit}
      forEmail={forEmail}
      onChange={onChange}
      {...element}
    />
  ),
  title: ({ element, id, inEdit, onChange }) => (
    <EditorTitle
      id={id}
      key={id}
      edit={inEdit}
      onChange={onChange}
      {...element}
    />
  ),
  paragraph: ({ element, id, inEdit, onChange, name, dynamicElement }) => {
    return (
      <EditorContent
        id={id}
        key={id}
        edit={inEdit}
        onChange={onChange}
        templateName={name}
        dynamicElement={dynamicElement}
        {...element}
      />
    );
  },
  button: ({ element, id, inEdit, onChange, activityId, forEmail }) => (
    <CallToAction
      id={id}
      key={id}
      edit={inEdit}
      activityId={activityId}
      forEmail={forEmail}
      onChange={onChange}
      {...element}
    />
  ),
};
